<template>
  <el-dialog
    title="查看课件详情"
    :visible.sync="dialogVisible"
    width="1000px"
    :append-to-body="true"
    :close-on-click-modal="false"
    :before-close="handleClose">
    <div>
      <Info
        title="课件信息"
        v-if="infoData"
        :data="infoData"
      />
      <TableBox
        title="课件更新记录"
        :tableHead="recordHead"
        :tableData="recordData"
        @onRowClick="onRowClick"
        @onBtns="onBtns"
      />
      <!--<TableBox-->
        <!--title="金币扣除"-->
        <!--subTitle="涉及到公共收费素材会进行扣除金币"-->
        <!--:is-order="true"-->
        <!--:is-page="true"-->
        <!--:tableHead="coinTableHead"-->
        <!--:tableData="coinTableData"-->
      <!--/>-->
    </div>
    <span slot="footer" class="dialog-footer">
    <el-button type="primary" @click="handleClose">确 定</el-button>
  </span>
  </el-dialog>
</template>

<script>
import * as ResultServer from '../../../../api/result'
import * as CourseServer from '../../../../api/course'
import Info from './components/info'
import TableBox from './components/tableBox'
import { recordHead } from './recordData'
import { coinTableHead } from './coinData'
// import LocalStorage from '../../../../../../utils/localStorageUtil'
import Config from '../../../../config/app'

export default {
  name: 'detail',
  components: {
    Info,
    TableBox,
  },
  props: {
    id: [Number, String],
    isMove: {
      type: Boolean,
      default: false
    },
    visible: Boolean,
    value: [Object, String],
    defaultValue: Object
  },
  watch: {
    visible (vl) { this.dialogVisible = vl },
    dialogVisible (vl) { this.$emit('update:visible', vl) },
    // value (vl) { this.form = vl },
    // 'form.value': {
    //   handler (vl) {
    //     this.$emit('update:value', vl)
    //   }
    // },
    defaultValue: {
      handler (vl) {
        this.form.map(v => {
          if (v.type === 'Select') {
            v.value = `${vl[v.attr]}`
          } else if (v.type === 'UploadTencent') {
            const img = vl[v.attr].split(',')
            v.value = img && img.map(v => { return { url: v } })
          } else {
            v.value = vl[v.attr]
          }
        })
      },
      deep: true,
      immediate: true
    }
  },
  created () {
    this.init()
  },
  data () {
    return {
      detailItem: null, // 课件详情信息
      online_enum: {
        true: '已上架',
        false: '下架中'
      },
      scene_enum: {
        online: '线上课件',
        offline: '线下课件',
        double_teacher: '双师课件'
      },
      package_status_enum: {
        unpublished: '未发布',
        run: '打包中',
        success: '成功',
        failure: '失败'
      },
      recordHead,
      recordData: [],
      coinTableHead,
      coinTableData: [],
      dialogVisible: this.visible,
      infoData: null
    }
  },
  methods: {
    init () {
      this.getDetail()
    },
    async onBtns (item, data, index) {
      console.log('行按钮==>', item, data, index)
      switch (item.key) {
        case 'setVersion': {
          // 设为发布版本
          const res = await ResultServer.updateResultIsOnline({
            resultId: data.result_id,
            attrId: data.result_attr_id,
            clientsId: this.$store.state.initConfig.school_id,
            is_online: 1
          })
          if (res.status_code === 200) {
            this.$message.success('设置成功')
          } else {
            this.$message.error('设置失败')
          }
          break
        }
        case 'preview': {
          console.log('预览==>')
          // 生成预览地址
          const webUrl = `${Config.imeditPreview}?id=${this.detailItem.id}&scene=preview&platform=vue&school_id=${this.$store.state.initConfig.school_id}&version=${data.result_attr_id}`
          window.open(webUrl)
          // 预览
          break
        }
      }
    },
    onRowClick (row) {
      console.log('选中行==>', row)
      // this.getPackDetail({ id: row.id, usersId: row.users_id })
    },
    async getDetail () {
      const res = await ResultServer.getResultDetail({
        id: this.id,
        clientsId: this.$store.state.selectSchoolId
      })
      const { data } = res

      this.detailItem = data

      // 获取分类结构名称
      const res2 = await CourseServer.getCourseRuleList({
        clientsId: this.$store.state.initConfig.school_id,
        parentId: 0
      })
      const arr = this.$utils.getParentNode(res2.data, data.category_id)
      let name = ''
      arr.forEach(v => {
        name += '>' + v.name
      })
      const catalogName = name.length > 0 ? name.slice(1) : name

      this.infoData = [
        { key: '课件名称：', value: data.name },
        { key: '课件标题：', value: data.title },
        { key: '创建人：', value: data.created_users.name, style: 'width: 60px' },
        { key: '创建时间：', value: data.created_at },
        { key: '创建账号：', value: data.updated_users.name },
        { key: '发布状态：', value: this.package_status_enum[data.package_status] },
        { key: '课件上架状态：', value: this.online_enum[data.is_online], style: 'width: 100px' },
        { key: '录制课上架状态：', value: this.online_enum[data.record_is_online], style: 'width: 120px' },
        { key: '分类规则结构：', value: catalogName, style: 'width: 100px' },
        { key: '课件图片：', value: data.cover, type: 'image' },
        { key: '课件类型：', value: this.scene_enum[data.type] },
        { key: '当前发布课件版本：', value: data.attr_id_used || '无', style: 'width: 130px' },
        { key: '教学知识点：', value: data.knowledge, type: 'content' },
        { key: '教学内容/剧情：', value: data.desc, type: 'content' }
        // { key: '发布时间：', value: data.attr_last.updated_at },
        // { key: '课件时间：', value: '--' },
        // { key: '更新状态：', value: data.package_status },
        // { key: '更新时间：', value: data.updated_at }
      ]

      // 获取更新记录
      const records = await ResultServer.getResultPackList({
        usersId: data.created_users_id,
        clientsId: this.$store.state.initConfig.school_id,
        resultId: this.id
      })
      this.recordData = records.items.map(v => {
        return {
          ...v,
          id: v.id,
          status: this.getStatus(v.result_attr.package_status),
          created_at: v.created_at,
          amount: v.amount,
          name: v.editor_user.name,
          mobile: v.editor_user.mobile,
          result_attr_id: v.result_attr_id,
          operation: [
            { key: 'preview', value: '预览' },
            { key: 'setVersion', value: '设为发布版本' }
          ]
        }
      })
      console.log('res==>getDetail', res, records)

      // 获取打包记录详情
      if (records.items[0] && records.items[0].id) {
        this.getPackDetail({
          id: records.items[0].id,
          usersId: records.items[0].users_id
        })
      }
    },
    getStatus (type) {
      let name = ''
      switch (`${type}`) {
        case 'success':
          name = '打包成功'
          break
        case 'failure':
          name = '打包失败'
          break
        case 'run':
          name = '打包中'
          break
        case 'unpublished':
          name = '未发布'
          break
        default:
      }
      return name
    },
    // 获取打包详情
    async getPackDetail ({ id, usersId }) {
      // 获取打包记录详情
      if (id) {
        const packDetail = await ResultServer.getResultPackDetail({
          id,
          usersId,
          clientsId: this.$store.state.initConfig.school_id
        })

        console.log('获取打包详情==>', packDetail)
        const detail = packDetail.data.bill_detail
        this.coinTableData = Object.keys(detail).map(v => {
          return {
            name: detail[v].name,
            number: detail[v].number,
            amount: detail[v].amount
          }
        })
      }
    },
    onAttr (item, index, target) {
      console.log('attr==>', item, index, target)
    },
    handleClose () {
      this.dialogVisible = false
    },
    submit () {
      const state = this.$refs.form.validateForm()
      const obj = this.$_.cloneDeepWith((this.defaultValue))
      if (state) {
        let img = []
        this.form.map(v => {
          img = []
          if (v.type === 'Select') {
            obj[v.attr] = `${v.value}`
          } else if (v.type === 'UploadTencent') {
            if (v.value && v.value.length > 0) {
              v.value.map(v => img.push(v.url))
            }
            obj[v.attr] = img.toString()
          } else {
            obj[v.attr] = v.value
          }
        })
        console.log(obj)
        // debugger
        this.$emit('success', obj)
        this.handleClose()
      }
    }
  }
}
</script>

<style scoped>

</style>
